/* tslint:disable */
/* eslint-disable */
/**
 * Bank Accounts API
 * API for managing bank accounts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateBankAccountCommand
 */
export interface CreateBankAccountCommand {
    /**
     * Unique identifier of the person who will own the account
     * @type {string}
     * @memberof CreateBankAccountCommand
     */
    personId: string;
    /**
     * International Bank Account Number
     * @type {string}
     * @memberof CreateBankAccountCommand
     */
    iban: string;
    /**
     * Bank Identifier Code (BIC/SWIFT)
     * @type {string}
     * @memberof CreateBankAccountCommand
     */
    bic?: string | null;
    /**
     * Label or name of the bank account
     * @type {string}
     * @memberof CreateBankAccountCommand
     */
    label: string;
    /**
     * Indicates if this should be the default bank account for the person
     * @type {boolean}
     * @memberof CreateBankAccountCommand
     */
    isDefault?: boolean;
}

/**
 * Check if a given object implements the CreateBankAccountCommand interface.
 */
export function instanceOfCreateBankAccountCommand(value: object): value is CreateBankAccountCommand {
    if (!('personId' in value) || value['personId'] === undefined) return false;
    if (!('iban' in value) || value['iban'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function CreateBankAccountCommandFromJSON(json: any): CreateBankAccountCommand {
    return CreateBankAccountCommandFromJSONTyped(json, false);
}

export function CreateBankAccountCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBankAccountCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'personId': json['personId'],
        'iban': json['iban'],
        'bic': json['bic'] == null ? undefined : json['bic'],
        'label': json['label'],
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
    };
}

export function CreateBankAccountCommandToJSON(json: any): CreateBankAccountCommand {
    return CreateBankAccountCommandToJSONTyped(json, false);
}

export function CreateBankAccountCommandToJSONTyped(value?: CreateBankAccountCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personId': value['personId'],
        'iban': value['iban'],
        'bic': value['bic'],
        'label': value['label'],
        'isDefault': value['isDefault'],
    };
}

